export const CHECKOUT_MAX_TICKETS = 20;

export const RESTRICTED_EVENT_ID = {
    ID: '23bb51af-e029-49a9-84c5-160d910a4ca0',
};